import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-progress-heart',
  templateUrl: './progress-heart.component.html',
  styleUrls: ['./progress-heart.component.scss']
})
export class ProgressHeartComponent implements OnInit {

  @Input() percentage: number = 0;
  @Input() size: number = 40;
  constructor() { }

  ngOnInit(): void {
  }

}
